import type { Post } from "@/types/content";

export const postsPart4: Post[] = [
  {
    id: "post-16",
    slug: "taipei-yoga-pilates-top6",
    title: "台北瑜珈皮拉提斯推薦 TOP 6｜小班課程全面評比",
    excerpt: "瑜珈與皮拉提斯的效果取決於老師的教學品質，大班課動作走樣也沒人管。神秘客走訪台北 18 間瑜珈皮拉提斯工作室，精選 6 間小班、老師細心的好去處。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_232b7d96a34e4703a79fa55c251913f6_08db8646.jpg",
    category: "瑜珈",
    tags: ["台北", "瑜珈", "皮拉提斯", "小班課", "健康養生", "懶人包", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室，對於師傅手法、產品成分與療程效果有敏銳的判斷力。堅持匿名探訪，每次評比都親自體驗完整流程，確保資訊真實可靠。",
    },
    publishedAt: "2025-05-02",
    readingTime: 9,
    rating: 4.6,
    reviewCount: 134,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>瑜珈和皮拉提斯的效果差異，90% 取決於老師的教學品質。大班課（20 人以上）老師根本看不到你的動作是否正確；小班課（8 人以下）才能讓老師關注到每個學員，及時調整，避免受傷同時提升效果。</p><p>神秘客走訪台北 18 間工作室，評比重點是：班級人數控制、老師的調整頻率、課後的體感差異，以及最重要的——你願不願意下次繼續去。</p>",
      },
      {
        _type: "shopReview",
        _key: "reviews",
        title: "TOP 6 瑜珈皮拉提斯工作室評比",
        shops: [
          {
            _key: "s1",
            name: "靜心瑜珈皮拉提斯",
            rating: 4.8,
            priceRange: "$800 - $2,000 /堂",
            address: "台北市信義區松壽路 36 號 5F",
            tags: ["8人小班", "空中瑜珈", "皮拉提斯"],
            pros: ["班級嚴格限制 8 人，老師能顧到每個人", "空中瑜珈設備安全且老師細心", "課後身體的感受明顯，不是走流程"],
            cons: ["課程價格偏高", "熱門時段需提前 2 週預約"],
            recommendation: "想認真改善體態或有舊傷需要復健的人首選。小班制是真的有差。",
            image: "https://readdy.ai/api/search-image?query=Bright%20yoga%20pilates%20studio%20with%20aerial%20silk%20equipment%20private%20class%20instructor%20helping%20student%20professional%20lighting%20simple%20background%20photography&width=600&height=400&seq=361&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=靜心瑜珈皮拉提斯+台北+信義區",
          },
          {
            _key: "s2",
            name: "身心流動工作室",
            rating: 4.7,
            priceRange: "$600 - $1,500 /堂",
            address: "台北市大安區臥龍街 150 號 3F",
            tags: ["陰瑜珈", "修復性課程", "孕婦瑜珈"],
            pros: ["老師都有國際 200 小時以上認證", "陰瑜珈和修復課程做得很好，適合工作壓力大的人", "孕婦瑜珈是市場少數有專業認證的"],
            cons: ["班級有時到 10 人，比標準稍大", "地點較不方便，需步行 10 分鐘"],
            recommendation: "壓力大、想放鬆的人或孕婦的首選。陰瑜珈做完像把積累的壓力全部釋放出來。",
            image: "https://readdy.ai/api/search-image?query=Intimate%20yoga%20studio%20with%20dim%20warm%20lighting%20yin%20yoga%20class%20students%20in%20relaxing%20poses%20restorative%20atmosphere%20simple%20background%20photography&width=600&height=400&seq=362&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=身心流動工作室+台北+大安區",
          },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "瑜珈皮拉提斯常見問題",
        items: [
          { _key: "q1", question: "瑜珈和皮拉提斯有什麼差別？", answer: "瑜珈來自印度，結合體式、呼吸、冥想，強調身心靈的連結。皮拉提斯來自西方，強調核心肌群的精準控制，更偏向肌力與體態矯正。兩者都很好，建議先上體驗課感受差異。" },
          { _key: "q2", question: "完全沒運動習慣可以上嗎？", answer: "當然可以！很多工作室都有初學者課程（Beginner 或 Level 1），老師會調整動作難度。關鍵是選對班級，不要一開始就上進階課。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多瑜珈皮拉提斯評比",
        subtitle: "神秘客實測台北瑜珈工作室，公正評比課程品質與老師教學",
        buttonLabel: "查看評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北瑜珈皮拉提斯推薦 TOP 6｜小班課程評比 2025",
      description: "台北瑜珈皮拉提斯評比！神秘客走訪 18 間工作室，精選 6 間小班制、老師細心的課程好去處。",
      keywords: ["台北瑜珈", "瑜珈推薦", "皮拉提斯", "小班瑜珈", "空中瑜珈"],
    },
  },
  {
    id: "post-17",
    slug: "taiwan-image-consulting-guide",
    title: "台灣形象管理懶人包｜什麼是形象顧問？適合誰？",
    excerpt: "形象管理不只是「穿什麼衣服」，而是幫你建立與內在一致的外在形象。這篇帶你了解形象管理的完整服務內容，以及如何找到適合自己的形象顧問。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_3843e545ee6af58ad11cede61ceca7c9_6c3812fb.jpg",
    category: "形象管理",
    tags: ["形象管理", "形象顧問", "穿搭", "職場形象", "色彩分析", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-04-12",
    readingTime: 8,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>形象管理（Image Consulting）近年在台灣快速成長，但很多人對它的認知還停留在「請人幫我買衣服」。其實形象管理的範疇包含了色彩分析、體型分析、衣櫃整理、場合穿搭建議、甚至到姿態與表達方式的調整。</p><p>對需要頻繁在公眾場合、職場上展現自我的人來說，形象管理是非常值得投資的服務。這篇幫你了解完整服務內容，以及如何選到適合自己的形象顧問。</p>",
      },
      {
        _type: "featureList",
        _key: "stores",
        title: "形象管理服務類型",
        features: [
          { _key: "s1", icon: "ri-palette-line", title: "色彩分析（Color Analysis）", description: "根據你的膚色、髮色、眼色，找出最適合你的色調系統（暖色/冷色、深/淺），讓穿搭更省力有效" },
          { _key: "s2", icon: "ri-body-scan-line", title: "體型分析", description: "了解自己的比例特點，學習如何透過服裝線條強化優點、平衡比例" },
          { _key: "s3", icon: "ri-shirt-line", title: "衣櫃整理與採購建議", description: "清理不適合的單品，建立膠囊衣櫥，讓每件衣服都好搭且符合你的形象目標" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "找形象顧問評比",
        subtitle: "美好時光指南收錄台灣靠譜形象顧問評比",
        buttonLabel: "查看形象顧問評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台灣形象管理懶人包｜形象顧問服務完整介紹",
      description: "形象管理入門指南！色彩分析、體型分析、衣櫃整理，教你如何找到適合自己的形象顧問。",
      keywords: ["形象管理", "形象顧問", "色彩分析", "台灣形象", "穿搭建議"],
    },
  },
  {
    id: "post-18",
    slug: "taiwan-bazi-fortune-guide",
    title: "命理諮詢懶人包｜八字、紫微、生命靈數怎麼選",
    excerpt: "台灣命理市場百花齊放，八字、紫微斗數、生命靈數各有擁護者。這篇帶你了解三大命理系統的差異，以及如何辨別靠譜的命理師。",
    coverImage: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20fortune%20telling%20with%20ancient%20texts%20and%20calligraphy%20tools%20incense%20burning%20spiritual%20consultation%20atmosphere%20warm%20candlelight%20simple%20background%20photography&width=1200&height=630&seq=118&orientation=landscape",
    category: "命理",
    tags: ["命理", "八字", "紫微斗數", "生命靈數", "身心靈", "懶人包"],
    author: {
      id: "author-2",
      name: "Chen 神秘客",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20man%20portrait%20confident%20smile%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=202&orientation=squarish",
      bio: "資深美業神秘客，專精美髮造型與頭皮護理類評測。走訪台灣超過 80 間美髮沙龍、頭皮護理中心與越式洗髮店，對於設計師技術、護理產品成分與頭皮檢測儀器有深入研究。堅持匿名探訪，給讀者最直白的消費建議。",
    },
    publishedAt: "2025-03-20",
    readingTime: 8,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>台灣是命理文化非常豐富的地方。從廟裡的籤詩、路邊的紫微師，到近年大量冒出的線上命理諮詢，選擇多到讓人眼花繚亂。</p><p>命理的目的是「了解自己的能量趨勢，做出更好的決策」，不是讓你陷入宿命論或恐懼未來。這篇幫你了解三大主流命理系統的差異，以及辨別靠譜命理師的方法。</p>",
      },
      {
        _type: "featureList",
        _key: "systems",
        title: "三大命理系統比較",
        features: [
          { _key: "s1", icon: "ri-fire-line", title: "八字（四柱推命）", description: "以出生年月日時為基礎，分析五行能量的搭配。是東方命理最精深的系統，需要命理師有豐富學問。解讀側重一生運勢格局" },
          { _key: "s2", icon: "ri-star-line", title: "紫微斗數", description: "以星曜組合分析命格，涵蓋範圍廣（個性、事業、感情、健康）。台灣最多人學習與實踐的命理系統" },
          { _key: "s3", icon: "ri-numbers-line", title: "生命靈數（數字學）", description: "僅需出生日期，計算簡單，入門門檻低。不如八字深入但適合做自我探索的起點，近年年輕人中很流行" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多命理師評比",
        subtitle: "美好時光指南收錄台灣靠譜命理師評比，幫你找到不恐嚇不推銷的好師傅",
        buttonLabel: "查看命理師評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "命理諮詢懶人包｜八字紫微生命靈數怎麼選",
      description: "台灣命理系統完整介紹！八字、紫微斗數、生命靈數差異比較，教你如何辨別靠譜命理師。",
      keywords: ["命理推薦", "八字推命", "紫微斗數", "生命靈數", "命理師"],
    },
  },
  {
    id: "post-19",
    slug: "taiwan-portrait-photography-guide",
    title: "台灣個人形象攝影懶人包｜第一次拍職業照完整攻略",
    excerpt: "個人品牌攝影、職業形象照越來越重要，但不知道該怎麼準備、找哪個攝影師。這篇帶你了解個人形象攝影的種類、準備流程，以及如何找到風格適合的攝影師。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_58ca33bfbcbbc718e01af28ba3f7cd19_b13d3583.jpg",
    category: "攝影",
    tags: ["攝影", "形象攝影", "職業照", "個人品牌", "台灣", "懶人包", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室，對於師傅手法、產品成分與療程效果有敏銳的判斷力。堅持匿名探訪，每次評比都親自體驗完整流程，確保資訊真實可靠。",
    },
    publishedAt: "2025-05-12",
    readingTime: 9,
    rating: 4.5,
    reviewCount: 87,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>個人形象攝影的需求越來越普遍——LinkedIn 的大頭照、IG 個人品牌、工作室官網的師傅介紹、書籍作者照，甚至只是想在特定年齡留下一張好看的自己。</p><p>但「拍照」這件事讓很多人緊張，不知道要擺什麼姿勢、穿什麼衣服、找哪種攝影師。這篇帶你從選攝影師到當天準備，完整攻略一次給你。</p>",
      },
      {
        _type: "featureList",
        _key: "types",
        title: "個人形象攝影類型",
        features: [
          { _key: "t1", icon: "ri-briefcase-line", title: "職業形象照（Business Headshot）", description: "用於 LinkedIn、名片、個人官網。乾淨俐落的風格，傳達專業感和可信度。通常 1-2 小時，單一或少數背景" },
          { _key: "t2", icon: "ri-user-star-line", title: "個人品牌攝影（Personal Branding）", description: "用於自媒體、課程、品牌形象。包含多種情境（辦公室、外景等），較完整呈現你的品牌個性" },
          { _key: "t3", icon: "ri-image-2-line", title: "形象寫真（Portrait）", description: "個人留念或社群使用，風格多元。可以是清新戶外也可以是精緻室內棚拍，強調個人美感" },
        ],
      },
      {
        _type: "featureList",
        _key: "tips",
        title: "拍攝前準備清單",
        features: [
          { _key: "p1", icon: "ri-shirt-line", title: "準備 2-3 套服裝", description: "包含一套正式（職業）、一套休閒（輕鬆）。避免純白或細條紋（相機不容易拍好）" },
          { _key: "p2", icon: "ri-palette-line", title: "妝髮建議輕底妝", description: "攝影燈光下妝容要比平日略重一些（約 20%）。頭髮要乾淨整齊，捲髮或造型提前預約" },
          { _key: "p3", icon: "ri-image-line", title: "準備參考圖", description: "收集 5-10 張你喜歡的風格參考圖給攝影師，讓他了解你想要的感覺比文字說明有效多了" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多個人形象攝影評比",
        subtitle: "神秘客評比台灣個人形象攝影師，公正分析風格與服務品質",
        buttonLabel: "查看攝影師評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台灣個人形象攝影懶人包｜職業照拍攝完整攻略",
      description: "個人形象攝影入門指南！職業照、個人品牌攝影完整攻略，含服裝準備、找攝影師技巧。",
      keywords: ["個人形象攝影", "職業照", "形象攝影", "個人品牌攝影", "台灣攝影師"],
    },
  },
  {
    id: "post-20",
    slug: "taiwan-iwatens-yu-guide",
    title: "岩盤浴懶人包｜台灣最夯的排毒舒壓體驗完整介紹",
    excerpt: "岩盤浴在台灣日漸流行，但很多人不知道岩盤浴和一般汗蒸幕有什麼不同、效果如何、適合什麼人。這篇完整介紹岩盤浴的一切，以及台灣值得去的岩盤浴推薦。",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20iwatens%20hot%20stone%20bed%20spa%20room%20warm%20infrared%20healing%20stones%20therapeutic%20wellness%20environment%20calm%20minimalist%20interior%20simple%20background%20photography&width=1200&height=630&seq=120&orientation=landscape",
    category: "岩盤浴",
    tags: ["岩盤浴", "排毒", "舒壓", "溫熱療法", "台灣", "懶人包", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-04-05",
    readingTime: 8,
    rating: 4.6,
    reviewCount: 95,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>岩盤浴（日語：岩盤浴 / いわばんよく）源自日本，是一種躺在加熱的天然礦石板上，讓身體從遠紅外線輻射熱中吸收能量的溫熱療法。和一般汗蒸幕最大的差別是：岩盤浴是「乾式」，讓身體從深處由內向外排汗，溫度通常在 40-45 度（比汗蒸幕溫和），但效果更持久。</p>",
      },
      {
        _type: "featureList",
        _key: "benefits",
        title: "岩盤浴的主要效果",
        features: [
          { _key: "b1", icon: "ri-drop-line", title: "深層排汗排毒", description: "遠紅外線能穿透皮膚 4-5 公分，促進深層組織排汗，帶走體內重金屬與代謝廢物" },
          { _key: "b2", icon: "ri-heart-pulse-line", title: "促進血液循環", description: "石板的持續溫熱促進微血管擴張，改善手腳冰冷、末梢循環不良" },
          { _key: "b3", icon: "ri-moon-line", title: "放鬆神經系統", description: "長時間躺臥 + 溫熱讓副交感神經活躍，改善睡眠品質、減少焦慮" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多岩盤浴評比",
        subtitle: "神秘客實測台灣岩盤浴場所，公正評比石材品質與環境衛生",
        buttonLabel: "查看岩盤浴評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "岩盤浴懶人包｜台灣岩盤浴完整介紹與推薦",
      description: "岩盤浴完整指南！什麼是岩盤浴、效果、和汗蒸幕的差別，以及台灣值得去的岩盤浴推薦。",
      keywords: ["岩盤浴", "台灣岩盤浴", "排毒", "溫熱療法", "岩盤浴推薦"],
    },
  },
];